"use client";

import {
  Navbar,
  Nav,
  Container,
  Offcanvas,
  Button,
} from "react-bootstrap";

import Link from "next/link";
import Image from "next/image";
import { useEffect, useState } from "react";
import { FaAngleDown } from "react-icons/fa";

import styles from "./NavbarSection.module.css";
import Logo from "@/app/assets/logo.svg";

/* ---------------------------------------------------------
   MENU DATA (WITH ICONS)
--------------------------------------------------------- */

// Infrastructure Hosting
const infraHosting: [string, string, string, string, string?][] = [
  [
    "/ad4.svg",
    "Managed Dedicated Servers",
    "High-performance servers with full management.",
    "",
    "https://www.temok.com/dedicated-servers-usa",
  ],
  [
    "/pr1.svg",
    "Managed Cloud Hosting",
    "High-availability cloud hosting with full management.",
    "AI-POWERED",
    "https://www.temok.com/managed-cloud-hosting",
  ],
  [
    "/pr3.svg",
    "Virtual Machines",
    "Flexible VMs with full control for apps and websites.",
    " ",
    "https://www.temok.com/linux-virtual-private-server-vps-usa",
  ],


  [
    "/hos3.svg",
    "Linux Reseller Hosting",
    "Scalable Linux reseller hosting for your clients.",
    " ",
    "https://www.temok.com/linux-reseller-hosting-usa",
  ],
  [
    "/hos5.svg",
    "Linux SEO Hosting",
    "Multi-IP SEO hosting for speed and rankings.",
    " ",
    "https://www.temok.com/linux-seo-hosting",
  ],
  [
    "/hos4.svg",
    "Windows Reseller Hosting",
    "Resell Windows hosting with WHMCS support.",
    " ",
    "https://www.temok.com/windows-reseller-hosting-usa",
  ],

];

// Networking (without domain items)
const networking: [string, string, string, string][] = [
  [
    "/ad2.svg",
    "Acronis Cyber Protect",
    "Advanced cyber protection with backup, disaster recovery, and security in one unified platform.",
    "https://www.temok.com/acronis-cyber-protect-cloud",
  ],
  [
    "/ggl1.svg",
    "Google Workspace",
    "Secure business email, cloud storage, and collaboration tools powered by Google for modern teams.",
    "https://www.temok.com/buy-google-workspace",
  ],
  [
    "/pr4.svg",
    "Networking",
    "Managed databases for fast, secure, scalable data handling.",
    "https://www.temok.com/managed-mongodb-hosting",
  ],
    ["/ad1.svg", "Proxies", "High-speed proxies for secure browsing.", "https://www.temok.com/proxies"],
  ["/ad3.svg", "VPN", "Private VPN service for online protection.", "https://www.temok.com/vpn"],
];

// Apps
const apps: [string, string, string, string ][] = [ 
  [
    "/hos1.svg",
    "Linux Shared Hosting",
    "Fast & reliable shared hosting for websites.", 
    "https://www.temok.com/linux-shared-hosting-usa",
  ],
  [
    "/hos2.svg",
    "Windows Shared Hosting",
    "Shared hosting built for ASP.NET and Windows apps.",
 
    "https://www.temok.com/windows-shared-hosting-usa",
  ],
  [
    "/ad2.svg", 
    "SSL", 
    "Secure your website with trusted SSL.",   
    "https://partners.temok.com/ssl"], 
  ["/ad5.svg", "Apple Mac Servers", "Mac Mini servers for development.",  "https://www.temok.com/apple-mac-mini-m2-usa"],
  ["/ad6.svg", "Linux VPS", "Fast & secure Linux VPS hosting.",   "https://www.temok.com/linux-virtual-private-server-vps-usa"],
  ["/ad7.svg", "Windows VPS", "Optimized Windows VPS hosting.",  "https://www.temok.com/windows-virtual-private-server-vps-usa"],
  ["/ad8.svg", "Windows RDP Servers", "High-speed RDP servers.",     "https://www.temok.com/windows-remote-desktop-usa"],
  ["/ad9.svg", "SEO RDP / VPS", "Multi-IP VPS hosting optimized for SEO.", "https://www.temok.com/seo-rdpvps"],
];

/* ---------------------------------------------------------
   SOLUTIONS
--------------------------------------------------------- */

const applicationHosting: [string, string, string][] = [
  ["/sol1.svg", "Managed Wordpress Cloud", "https://www.temok.com/managed-wordpress-cloud-hosting"],
  ["/sol2.svg", "Managed Magento Cloud", "https://www.temok.com/managed-magento-cloud-hosting"],
  ["/sol3.svg", "Managed PHP Cloud", "https://www.temok.com/managed-php-cloud-hosting"],
  ["/sol4.svg", "Managed Laravel Cloud", "https://www.temok.com/managed-laravel-cloud-hosting"],
  ["/sol5.svg", "Managed Drupal Cloud", "https://www.temok.com/managed-drupal-cloud-hosting"],
  ["/sol6.svg", "Managed Joomla Cloud", "https://www.temok.com/managed-joomla-cloud-hosting"],
  ["/sol7.svg", "Managed Prestashop Cloud", "https://www.temok.com/managed-prestashop-cloud-hosting"],
  ["/sol8.svg", "Managed WooCommerce Cloud", "https://www.temok.com/managed-woocommerce-cloud-hosting"],
  ["/sol9.svg", "Managed Odoo Hosting", "https://www.temok.com/managed-odoo-hosting"],
  ["/sol10.svg", "Managed OpenCart Hosting", "https://www.temok.com/managed-opencart-hosting"],
];

const databaseHosting: [string, string, string][] = [
  ["/sol11.svg", "Managed MySQL Hosting", "https://www.temok.com/managed-mysql-hosting"],
  ["/sol12.svg", "Managed Redis Hosting", "https://www.temok.com/managed-redis-hosting"],
  ["/sol13.svg", "Managed MongoDB Hosting", "https://www.temok.com/managed-mongodb-hosting"],
  ["/sol14.svg", "Managed MariaDB Hosting", "https://www.temok.com/managed-mariadb-hosting"],
  ["/sol15.svg", "Managed Oracle Hosting", "https://www.temok.com/managed-oracle-hosting"],
  ["/sol16.svg", "Managed PostgreSQL Hosting", "https://www.temok.com/managed-postgresql-hosting"],
  ["/sol17.svg", "Managed Elasticsearch Hosting", "https://www.temok.com/managed-elasticsearch-hosting"],
  ["/sol18.svg", "Managed Kafka Hosting", "https://www.temok.com/managed-kafka-hosting"],
  ["/sol19.svg", "Managed Prometheus Hosting", "https://www.temok.com/managed-prometheus-hosting"],
];

const cloudHosting: [string, string, string][] = [
  ["/sol20.svg", "Managed DigitalOcean Cloud", "https://www.temok.com/managed-digitalocean-hosting"],
  ["/sol21.svg", "Managed Amazon Cloud (AWS)", "https://www.temok.com/managed-amazon-cloud-hosting"],
  ["/sol22.svg", "Managed Hyper-V Cloud Hosting", "https://www.temok.com/managed-hyper-v-cloud-hosting"],
  ["/sol23.svg", "Managed Kubernetes Hosting", "https://www.temok.com/managed-kubernetes-hosting"],
];

/* ---------------------------------------------------------
   DOMAINS MENU (NEW)
--------------------------------------------------------- */
const domainsMenu: [string, string, string][] = [
  ["/pr2.svg", "https://www.temok.com/domain-registrations", "Domain Registrations"],
  ["/pr2.svg", "https://www.temok.com/international-domains", "International Domains"],
  ["/pr2.svg", "https://www.temok.com/bulk-registration", "Bulk Registration"],
  ["/pr2.svg", "https://clients.temok.com/cart.php?a=add&domain=transfer", "Bulk Transfer"],
  ["/pr2.svg", "https://clients.temok.com/cart.php?a=add&domain=transfer", "Domain Transfer"],
  ["/pr2.svg", "https://www.temok.com/domain-pricing", "Domain Pricing"],
  ["/pr2.svg", "https://clients.temok.com/index.php?rp=/login", "Domain Renewals"],
];

/* ---------------------------------------------------------
   RESOURCES MENU
--------------------------------------------------------- */
const resourcesMenu: [string, string, string][] = [
  ["/reso1.svg", "https://www.temok.com/about-us", "About Us"],
  ["/reso2.svg", "https://www.temok.com/contact-us", "Contact Us"],
  ["/reso3.svg", "https://www.temok.com/privacy-policy", "Privacy Policy"],
  ["/reso3.svg", "https://www.temok.com/terms-of-use", "Terms & Conditions"],
  ["/reso5.svg", "https://www.temok.com/dmca", "DMCA"],
  ["/reso6.svg", "https://www.temok.com/blog", "Blog"],
  ["/reso7.svg", "https://www.shareasale.com/shareasale.cfm?merchantID=68808", "Affiliates"],
];

/* ---------------------------------------------------------
   PARTNERSHIPS
--------------------------------------------------------- */
const partnershipsMenu: [string, string, string][] = [
  ["/reso7.svg", "/", "Reseller Partner Program"],
  ["/reso2.svg", "/whitelabel-managed-service-providers", "WhiteLabel Managed Service Providers"],
  ["/reso6.svg", "/affiliates-program", "Affiliate Program"],
];

/* ---------------------------------------------------------
   NAVBAR COMPONENT
--------------------------------------------------------- */

export default function NavbarSection() {
  const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState({
    products: false,
    solutions: false,
    domains: false,
    resources: false,
    partnerships: false,
  });

  const [expanded, setExpanded] = useState({
    products: false,
    solutions: false,
    domains: false,
    resources: false,
    partnerships: false,
  });

  // const toggle = (key: "products" | "solutions" | "domains" | "resources" | "partnerships") =>
  //   setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  const toggle = (
    key: "products" | "solutions" | "domains" | "resources" | "partnerships"
  ) => {
    // Mobile/tablet: only one menu open at a time
    if (isMobile) {
      setOpen({
        products: false,
        solutions: false,
        domains: false,
        resources: false,
        partnerships: false,
        [key]: !open[key],
      });
    } else {
      // Desktop hover: normal toggle behavior
      setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
    }
  };
  

  const handleLoadMoreToggle = (key: "products" | "solutions" | "domains" | "resources" | "partnerships") =>
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth < 992);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <>
      <div className={styles.navbarWrapper}>
        <Navbar expand="lg" className={styles.navbar}>
          <Container>
            {/* LOGO */}
            <Link href="https://temok.com/" className={styles.logoWrapper}>
              <Image src={Logo} alt="Temok" width={120} height={34} />
            </Link>

            {/* MOBILE TOGGLE */}
            <Navbar.Toggle
              aria-controls="mobile-offcanvas"
              className={styles.toggle}
            />

            {/* OFFCANVAS */}
            <Navbar.Offcanvas
              id="mobile-offcanvas"
              placement="end"
              className={styles.offcanvas}
            >
              <Offcanvas.Header closeButton>
                <Image src={Logo} alt="Temok" width={120} height={34} />
              </Offcanvas.Header>

              <Offcanvas.Body>
                <Nav className={`mx-auto ${styles.navLinks}`}>

                  {/* PRODUCTS */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("products") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("products") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.products ? "active" : ""
                      }`}
                      onClick={() => toggle("products")}
                    >
                      Products <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.products && (
                      <div
                        className={
                          isMobile ? styles.megaMenuSmall : styles.megaMenu
                        }
                      >
                        <div className={styles.smallInner}>
                          <div
                            className={isMobile ? styles.smallBox : styles.megaCard}
                          >
                            <div className={styles.megaGrid}>
                              {/* Column 1 */}
                              <div>
                                <p className={styles.megaHeading}>
                                  Infrastructure Hosting
                                </p>

                                {(expanded.products
                                  ? infraHosting
                                  : infraHosting.slice(0, 4)
                                ).map(([icon, title, desc, tag, url = "#"]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>
                                        {title}
                                        {tag && (
                                          <span
                                            className={
                                              tag === "NEW"
                                                ? styles.badgeGreen
                                                : styles.badgeBlue
                                            }
                                          >
                                            {tag}
                                          </span>
                                        )}
                                      </h4>
                                      <p>{desc}</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>

                              {/* Column 2 */}
                              <div>
                                <p className={styles.megaHeading}>
                                  Networking
                                </p>

                                {(expanded.products
                                  ? networking
                                  : networking.slice(0, 4)
                                ).map(([icon, title, desc, url]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>{title}</h4>
                                      <p>{desc}</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>

                              {/* Column 3 */}
                              <div>
                                <p className={styles.megaHeading}>
                                  Apps & Servers
                                </p>

                                {(expanded.products ? apps : apps.slice(0, 4)).map(
                                  ([icon, title, desc, url]) => (
                                    <Link
                                      href={url}
                                      key={title}
                                      className={`${styles.megaItem} text-decoration-none`}
                                    >
                                      <Image src={icon} width={28} height={28} alt="" />
                                      <div>
                                        <h4>{title}</h4>
                                        <p>{desc}</p>
                                      </div>
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>

                            {(
                              infraHosting.length > 4 ||
                              networking.length > 4 ||
                              apps.length > 4
                            ) && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("products")}
                                >
                                  {expanded.products ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* SOLUTIONS */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("solutions") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("solutions") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.solutions ? "active" : ""
                      }`}
                      onClick={() => toggle("solutions")}
                    >
                      Solutions <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.solutions && (
                      <div className={styles.megaMenuSolutions}>
                        <div className={styles.innerContainer}>
                          <div className={styles.megaSolutionsCard}>
                            <div className={styles.megaSolutionsGrid}>
                              {/* Application Hosting */}
                              <div>
                                <p className={styles.megaHeading}>Application Hosting</p>

                                {(expanded.solutions
                                  ? applicationHosting
                                  : applicationHosting.slice(0, 4)
                                ).map(([icon, title, url]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>{title}</h4>
                                      <p>Fully managed. Optimized.</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>

                              {/* Database Hosting */}
                              <div>
                                <p className={styles.megaHeading}>Database Hosting</p>

                                {(expanded.solutions
                                  ? databaseHosting
                                  : databaseHosting.slice(0, 4)
                                ).map(([icon, title, url]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>{title}</h4>
                                      <p>Fully managed DB clusters.</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>

                              {/* Cloud Hosting */}
                              <div>
                                <p className={styles.megaHeading}>Cloud Hosting</p>

                                {(expanded.solutions
                                  ? cloudHosting
                                  : cloudHosting.slice(0, 4)
                                ).map(([icon, title, url]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>{title}</h4>
                                      <p>Fully managed cloud environments.</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>
                            </div>

                            {(
                              applicationHosting.length > 4 ||
                              databaseHosting.length > 4 ||
                              cloudHosting.length > 4
                            ) && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("solutions")}
                                >
                                  {expanded.solutions ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* DOMAINS — NEW DROPDOWN */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("domains") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("domains") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.domains ? "active" : ""
                      }`}
                      onClick={() => toggle("domains")}
                    >
                      Domains <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.domains && (
                      <div className={styles.megaMenuSmall}>
                        <div className={styles.smallInner}>
                          <div className={styles.smallBox}>
                            {(expanded.domains
                              ? domainsMenu
                              : domainsMenu.slice(0, 4)
                            ).map(([icon, url, label]) => (
                              <Link
                                href={url}
                                key={label}
                                className={`${styles.megaItem} text-decoration-none`}
                              >
                                <Image src={icon} width={22} height={22} alt={label} />
                                <div>
                                  <h4>{label}</h4>
                                  <p>Manage {label.toLowerCase()}.</p>
                                </div>
                              </Link>
                            ))}

                            {domainsMenu.length > 4 && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("domains")}
                                >
                                  {expanded.domains ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* PARTNERSHIPS */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("partnerships") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("partnerships") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.partnerships ? "active" : ""
                      }`}
                      onClick={() => toggle("partnerships")}
                    >
                      Partnerships <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.partnerships && (
                      <div className={styles.megaMenuSmall}>
                        <div className={styles.smallInner}>
                          <div className={styles.smallBox}>
                            {(expanded.partnerships
                              ? partnershipsMenu
                              : partnershipsMenu.slice(0, 4)
                            ).map(([icon, url, label]) => (
                              <Link
                                href={url}
                                key={label}
                                className={`${styles.megaItem} text-decoration-none`}
                              >
                                <Image src={icon} width={22} height={22} alt={label} />
                                <div>
                                  <h4>{label}</h4>
                                  <p>Learn more about {label.toLowerCase()}.</p>
                                </div>
                              </Link>
                            ))}

                            {partnershipsMenu.length > 4 && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("partnerships")}
                                >
                                  {expanded.partnerships ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* RESOURCES */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("resources") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("resources") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.resources ? "active" : ""
                      }`}
                      onClick={() => toggle("resources")}
                    >
                      Resources <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.resources && (
                      <div className={styles.megaMenuSmall}>
                        <div className={styles.smallInner}>
                          <div className={styles.smallBox}>
                            {(expanded.resources
                              ? resourcesMenu
                              : resourcesMenu.slice(0, 4)
                            ).map(([icon, url, label]) => (
                              <Link
                                href={url}
                                key={label}
                                className={`${styles.megaItem} text-decoration-none`}
                              >
                                <Image src={icon} width={22} height={22} alt={label} />
                                <div>
                                  <h4>{label}</h4>
                                  <p>Learn more about {label.toLowerCase()}.</p>
                                </div>
                              </Link>
                            ))}

                            {resourcesMenu.length > 4 && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("resources")}
                                >
                                  {expanded.resources ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Nav>

                {/* RIGHT SECTION */}
                <Nav className={styles.rightSection}>
                  <Link
                    href="https://clients.temok.com/login.php"
                    className={`${styles.loginLink} text-decoration-none`}
                  >
                    Log in
                  </Link>

                  <Link href="https://clients.temok.com/register.php">
                    <Button className={styles.getStarted}>Get Started</Button>
                  </Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </div>
    </>
  );
}
